import { Suspense, type FunctionComponent, type RefObject } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyPlanner: FunctionComponent<{
  screenManagerRef: RefObject<HTMLDivElement>;
}> = ({ screenManagerRef }) => {
  const Planner = useLazyComponent(
    () => import(/* webpackChunkName: "planner" */ './Planner'),
    { namedImport: 'Planner' },
  );

  return (
    <ErrorBoundary>
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <Planner screenManagerRef={screenManagerRef} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
